import * as yup from 'yup'

export const createResellerSchema = yup.object().shape({
    customer_id: yup
        .number()
        .required('Customer ID is required')
        .positive('Customer ID must be positive'),
    reseller_name: yup
        .string()
        .required('Reseller name is required')
        .min(2, 'Reseller name must be at least 2 characters'),
    reseller_tier: yup.string().optional(),
})
